import React from 'react';
import {createRoot} from "react-dom/client";
import { Provider } from 'react-redux'
import {store} from './state/store'
import {QuickPublishPopup} from "./layout/QuickPublishPopup/QuickPublishPopup";
import './translations/i18n';
import {InformationTooltipWrapper} from './components/InformationTooltip/InformationTooltipWrapper';

createRoot(document.getElementById('quick-publish-root')).render(
    <React.StrictMode>
        <Provider store={store}>
            {window.authenticatedIndexUserId &&
                <QuickPublishPopup/>
            }
            <InformationTooltipWrapper/>
        </Provider>
    </React.StrictMode>
)

if (module.hot) module.hot.accept();
